import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { DropDown, Header, SearchBars, Sides, Tabbles } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { actionDoctor } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { PiBinoculars, PiDotsThreeOutlineVertical } from "react-icons/pi";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { LuFileSearch2 } from "react-icons/lu";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

const EmergencyCalls = ({ loginData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({
        doctorGuid: loginData.userGuid,
        currency: loginData?.currencyCode
    });
    const [dateRange, setDateRange] = useState([null, null]);
    const [options, setOptions] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");
    const [search, setSearch] = useState("");
    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };
    useEffect(() => {
        dispatch(actionDoctor.getClinicDoctor(loginData.userGuid));
    }, [dispatch, loginData]);
    const getClinicDoctorData = useSelector(
        (state) => state.doctor.getClinicDoctorData?.data
    );
    useEffect(() => {
        if (getClinicDoctorData) {
            const newOption = getClinicDoctorData?.result?.map((item) => ({
                value: item.clinicGuid,
                label: item.clinicName,
            }));
            setOptions(newOption);
        }
    }, [getClinicDoctorData]);
    const handleChange = (type, value) => {
        switch (type) {
            case "search":
                setSearch(value);
                break;
            case "clinic":
                setSelectedClinic(value);
                break;
            default:
                break;
        }
    };

    const onSearchClick = () => {
        // let formattedFromDate = null;
        // let formattedToDate = null;

        // if (dateRange?.[0] && dateRange?.[1]) {
        //   const fromDate = new Date(dateRange[0].getTime() - dateRange[0].getTimezoneOffset() * 60000);
        //   const toDate = new Date(dateRange[1].getTime() - dateRange[1].getTimezoneOffset() * 60000);

        //   formattedFromDate = fromDate.toISOString().split(".")[0] + ".000";
        //   formattedToDate = toDate.toISOString().split(".")[0] + ".000";
        // }
        // let clinicGuid = selectedClinic?.value || '';
        // if (clinicGuid === loginData.clinicGuid) {
        //   clinicGuid = '';
        // }
        // console.log("Selected Date Range:", formattedFromDate, formattedToDate);
        // console.log("Selected Clinic:", clinicGuid);

        // // pageSize, currentPage, search, sortExp, sortDir, patientGuid, doctorGuid, appointmentStatuses, fromDate, toDate, isRequiredRefundData, IsRequiredCommissionData, UserCurrency, UserTimeZone, clinicGuid, isOwn, isAnother, LanguageId, appointmentTypes,
        // dispatch(actionPatient.getAppointments(10, 1, search, "", "", "", loginData.userGuid, null, formattedFromDate, formattedToDate, true, true, loginData?.currencyCode, loginData.timeZoneId, clinicGuid, true, false, 1, appointmentTypes))
    };

    useEffect(() => {
        dispatch(actionDoctor.getEmergencyCallByDoctor(credentials));
    }, [dispatch, credentials]);
    const getEmergencyCallByDoctorData = useSelector(
        (state) => state.doctor.getEmergencyCallByDoctorData?.data
    );

    const handleSelect = (id, appointment) => {

        if (id === "create-invoice") {
            navigate(
                `/doctor/generate-invoice`,
                { state: { appointment } }
            );
        } else if (id === "view-invoice") {
            if (appointment?.pdfUrl) {
                window.open(appointment.pdfUrl, "_blank");
            }
        }
    };


    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage pageHeading={t("Emergency_Calls")} />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <SearchBars.SearchBar
                        className="search-bar"
                        cDateRangeClassname="custom-date-range-picker"
                        select2Classname="select3"
                        searchGrpClassName="form-group1"
                        buttonClassname="btn-solid-Aqua_Teal"

                        showDate={true}
                        showSelect2={true}

                        datepickerlg={3}
                        selectCollg2={3}
                        searchCollg={5}
                        buttonCollg={1}

                        datepickermd={3}
                        selectColmd2={4}
                        searchColmd={3}
                        buttonColmd={2}

                        cDateRangePlaceholder={t("select_date")}
                        select2Placeholder={t("Select") + " " + t("Clinic")}
                        searchPlaceholder={t("Search")}
                        dateRange={dateRange}
                        select2Value={selectedClinic}
                        searchValue={search}

                        select2Options={options}
                        onDateRangeChange={handleDateRangeChange}
                        onClinicChange={(selected) => handleChange("clinic", selected)}
                        onSearchChange={(e) => handleChange("search", e.target.value)}

                        buttonChildren={<PiBinoculars className="bionCularIcon" />}
                        onSearchClick={onSearchClick}

                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<HiOutlinePhoneMissedCall className="header-Icn" />}
                        heading={t("Emergency_Calls")}
                        columns={[
                            `${t("booking_id")}`,
                            `${t("doctor_name")}`,
                            `${t("patient_name")}`,
                            `${t("time_&_date")}`,
                            `${t("medical_specialty")}`,
                            `${t("Diagnosis")}`,
                            loginData?.currencyCode,
                            "",
                        ]}
                        data={getEmergencyCallByDoctorData?.result?.filter((emergency) => emergency.status === 2).map((emergency) => ({
                            [t("booking_id")]: emergency.bookingId,
                            [t("doctor_name")]: emergency.doctorName,
                            [t("patient_name")]: emergency.patientName,
                            [t("time_&_date")]: (
                                <>
                                    <div>
                                        {new Date(emergency.appointmentDateTime).toLocaleTimeString(
                                            "en-US",
                                            {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            }
                                        )}
                                    </div>
                                    <div>
                                        {new Date(emergency.appointmentDateTime)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, " - ")}
                                    </div>
                                </>
                            ),
                            [t("medical_specialty")]: emergency.medicalSpeciality,
                            [t("Diagnosis")]: (
                                <div className="editBlkIcon">
                                    <LuFileSearch2
                                        className="editIcon"
                                    // onClick={() => handleRequest(request, 2)}
                                    />
                                </div>
                            ),
                            [loginData?.currencyCode]: emergency.consultFees,
                            "": (
                                <DropDown.DropDown
                                    className="moreaction-dropdown"
                                    drpDwnText={
                                        <PiDotsThreeOutlineVertical className="moreAction" />
                                    }
                                    drpItems={[
                                        {
                                            id: "create-invoice",
                                            label: t("create_invoice"),
                                        },
                                        emergency?.pdfUrl && {
                                            id: "view-invoice",
                                            label: t("view_invoice"),
                                        },
                                    ]}
                                    onSelect={(id) => handleSelect(id, emergency)}
                                />
                            ),
                        }))}

                        tabbleClassname="tabble"
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default EmergencyCalls;
